module.exports = __webpack_public_path__ + "static/img/model-bg20.f0a7a14.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg20.jpg
// module id = Txc2
// module chunks = 0